module.exports = __webpack_public_path__ + "a1049e3214a036890231de4d4b29d803.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/taiwan-08.png
// module id = 476
// module chunks = 0